import { AddressDto, CustomerDto } from './index';

export class Customer implements CustomerDto {
  address!: AddressDto;
  companyName!: string;
  email!: string;
  firstName!: string;
  iban!: string;
  initials!: string;
  insertion!: string;
  kvkNumber!: string;
  lastName!: string;
  phoneNumber!: string;
}
